import { render } from "./InfoBefore.vue?vue&type=template&id=83d89312"
import script from "./InfoBefore.vue?vue&type=script&lang=js"
export * from "./InfoBefore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__